import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Contract from "../../../models/Contract";
import { useContract, useContracts } from "../../../networking/contract.hooks";
import AutoCompleteInput, { AutoCompleteInputProps } from "./AutoCompleteInput";

interface Props
	extends Pick<AutoCompleteInputProps<string, Contract>, "width" | "icon" | "placeholder"> {
	onChange: (customerId?: string) => any;
	value: string;
	hidePrefix?: boolean;
}

const ContractAutoComplete: React.FC<Props> = ({ value, onChange, hidePrefix, ...rest }) => {
	const [search, setSearch] = useState<string>();
	const { t } = useTranslation();

	const { contracts } = useContracts(
		{
			page: 1,
			pageSize: 20,
			sort: "name",
			keyword: search,
		},
		!!search
	);

	const { contract } = useContract({ contractId: value }, !!value);

	return (
		<AutoCompleteInput<string, Contract>
			value={value}
			getDisplayValue={(c) =>
				`${c?.name || ""}${c?.isDeleted ? ` (${t("contract.archived").toLowerCase()})` : ""}`
			}
			suggestions={contracts || []}
			getValue={(c) => c.id}
			onSearch={setSearch}
			minChars={1}
			prefix={hidePrefix ? undefined : t("CONTRACT")}
			onChange={onChange}
			initialValueSuggestion={contract}
			{...rest}
		/>
	);
};

export default ContractAutoComplete;
